// console.log('dagdeelboeking')

// var dagen = ['ma','di','wo','do','vr']
// var selectedDriverId = 0



// window.agendaLoaded = function (){
//     setTimeout(async () => {
//         render()
//     }, 1000);
// }


// //on rerender
// //remember selected dropdowns(just the)
// // save selected kpter in url

// async function render(){
    

//     //get the current data

//     var [drivers,practices,users,roles,schedules] = await Promise.all([
//         fetch(`${__URLS__["api"]}drivers`,{
//             method: 'GET',
//             headers: {
//                 "Content-Type": "application/json",
//                 "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//             },
//             })
//             .then(res => res.json()),
//         window.getPaulAsync('practice','',''),
//         window.getPaulAsync('user','',''),
//         window.getPaulAsync('user_practice_role','',''),
//         window.getPaulAsync('user_practice_schedule','',''),
//     ])

//     //use bumbal api to retrieve available times in 4 months
//     // user.bumbalDriverId
    

//     var anchor = document.querySelector('#anchorid')
//     anchor.innerHTML = ''
//     startContext(anchor)
//     //get all practices
//     //filter out the ones for which you're preffered
//     div({class:'dagdeelboeking'})
//         var selectstyle = `
//             border: 1px solid black;
//             padding: 10px;
//             border-radius: 20px;
//             font-size: 16px;
//             margin-bottom:10px;
//         `
//         var driverdropdown = cr('select',{style:selectstyle,placeholder:'KPTer'}).on('change',(e) => {
//             selectedDriverId = e.target.value
//             var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?driverid=${e.target.value}`;
//             window.history.pushState({path:newurl},'',newurl)
            
//             render()
//         })
//             crend('option','')
//             for(var driver of drivers){
//                 crend('option',driver.first_name,{value:driver.id})
//             }
//         end()
//         driverdropdown.value = getQueryParam('driverid') ?? ''
//         selectedDriverId = driverdropdown.value
//         crend('br')
//         div({id:'listcontainer'})
//             var relevantSchedules = schedules.filter(s => s.userid == selectedDriverId)
//             var alreadychosenPractices = relevantSchedules.map(s => s.practiceid)
//             var relevantPractices = practices.filter(p => p.preferredDriverId == selectedDriverId)
//             relevantPractices = relevantPractices.filter(p => alreadychosenPractices.includes(p.id) == false)
//             cr('select',{style:selectstyle,placeholder:"praktijk"}).on('change',async (e) => {
//                 //post a new row
//                 await fetch(`${__URLS__["api"]}paul/user_practice_schedule`,{
//                 method: 'POST',
//                 headers: {
//                     "Content-Type": "application/json",
//                     "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//                 },
//                 body:JSON.stringify({
//                     practiceid:parseInt(e.target.value),
//                     userid:parseInt(selectedDriverId),
//                 })
//                 })
//                 .then(res => res.json())
//                 render()
//             })
//                 crend('option')
//                 for(var practice of relevantPractices){
//                     crend('option',practice.name,{value:practice.id})
//                 }
//             end()
//             for(let schedule of relevantSchedules){
//                 let practice = practices.find(p => p.id == schedule.practiceid)
//                 let practiceUIcomponents = {}
//                 div({style:"display:flex;flex-direction:column;align-items:flex-start;"})
//                     crend('b',practice.name)
//                     div({style:'display:flex; gap:20px;'})
//                         var buttonstyle = `padding: 10px;
//                             border-radius: 20px;
//                             background: white;
//                             border: 1px solid black;
//                             font-family: 'Jura';
//                             font-size: 16px;
//                             cursor: pointer;`
//                         crend('button','delete',{style:buttonstyle}).on('click',async () => {
//                             if(confirm('weet je zeker dat je dit wilt deleten?') == false){
//                                 return
//                             }
//                             await fetch(`${__URLS__["api"]}paul/user_practice_schedule/${schedule.id}`,{
//                                 method: 'DELETE',
//                                 headers: {
//                                     "Content-Type": "application/json",
//                                     "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//                                 }
//                             })
//                             .then(res => res.json())
//                             render()
//                         })
//                         crend('button','save',{style:buttonstyle}).on('click',async () => {
//                             let updateobject = {}
//                             updateobject.id = schedule.id
//                             updateobject.userid = parseInt(selectedDriverId);
//                             updateobject.practiceid = practice.id;
//                             for(let key in practiceUIcomponents){
//                                 let value = practiceUIcomponents[key].value
//                                 if(value){
//                                     updateobject[key] = value
//                                 }
//                             }

//                             await fetch(`${__URLS__["api"]}paul/user_practice_schedule/update`,{
//                                 method: 'PUT',
//                                 headers: {
//                                     "Content-Type": "application/json",
//                                     "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//                                 },
//                                 body:JSON.stringify(updateobject)
//                             })
//                             .then(res => res.json())

//                             toastr.success('saved')
//                             //rerender
//                         })
//                     end()
//                     cr('div')
//                         cr('label')
//                             text('afspraak duur')
//                             cr('div')
//                                 let duurselectelem = cr('select',{style:`border: 1px solid black;
//                                         border-radius: 20px;
//                                         padding: 10px;`})
//                                     crend('option','0:30',{value:0.5})    
//                                     crend('option','1',{value:1})
//                                     crend('option','1:30',{value:1.5})
//                                     crend('option','2',{value:2})
//                                     crend('option','2:30',{value:2.5})
//                                     crend('option','3',{value:3})
//                                     crend('option','3:30',{value:3.5})
//                                     crend('option','4',{value:4})
//                                 end()
//                             end()
//                         end()
//                     end()

//                     div({style:'display:flex;'})
//                         for(var dag of dagen){
//                             div({style:'display:flex; flex-direction:column;'})
//                                 crend('b',dag)
//                                 cr('label')
//                                     async function handletimeinput(e){
//                                         var futuredate = moment().add(16,"weeks").format("YYYY-MM-DD")
//                                         //get practice address
//                                         //get driver id
                                        
//                                         var res = await checkAvailabiltity(duurselectelem.value * 60,futuredate,{
//                                             "street_1": practice.street,
//                                             "house_nr": practice.house_nr,
//                                             "city": practice.city,
//                                             "zipcode": practice.zipcode,
//                                             "iso_country": "nl"
//                                         },selectedDriverId)
//                                         console.log(res)


//                                         dialogelem.innerHTML = ''
//                                         startContext(dialogelem)
//                                             for(let window of res.additional_data.available_timewindows){
//                                                 let startdate = moment(window.date_time_from)
//                                                 let range = `${startdate.format('HH:mm')}-${startdate.add(duurselectelem.value,'hours').format('HH:mm')}`
//                                                 crend('div',range,{style:"cursor:pointer;"}).on('click',() => {
//                                                     e.target.value = range
//                                                     dialogelem.close()
//                                                 })
//                                             }
//                                         endContext()
//                                         dialogelem.showModal();
//                                     }
//                                     practiceUIcomponents[dag + 'even'] = crend('input','',{readonly:true,value:schedule[dag + 'even'] ?? '',placeholder:'even',
//                                         style:'cursor:pointer; border: 1px solid black; margin:5px; padding:11px; border-radius:22px;'})
//                                     .on('click',handletimeinput)
//                                 end()
//                                 cr('label')
//                                     practiceUIcomponents[dag + 'uneven'] = crend('input','',{readonly:true,value:schedule[dag + 'uneven'] ?? '',placeholder:'uneven',
//                                         style:'border: 1px solid black; margin:5px; padding:11px; border-radius:22px;'})
//                                     .on('click',handletimeinput)
//                                 end()
//                             end()
//                         }
//                     end()
//                 end()
//             }
//             crend('button','testbutton',{}).on('click',async () => {
//                 return fetch(`${__URLS__["api"]}paul/generatedagdelen`,{
//                     method: 'POST',
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//                     },
//                 }).then(res => res.json())


//             })
//         end()
//     end()

//     var dialogelem = crend('dialog','',{closedby:'any',style:"border-radius:20px; padding:50px;"})
    
//     endContext()


// }


// async function checkAvailabiltity(duration,date,address,driverid){
//     var result =  await bumbalCall('/planner/check-availability','POST',{
//         "data": {
//             "activity": {
//                 "activity_type_name": "stop",
//                 "duration": duration,
//                 "address": address,
//                 "driver_id":driverid,

//             },
//             "tag_names": [
//                 "blok","implant"
//             ],
//         },
//         "filters":{
//             "date_from":date,
//             "date_to":date
//         },
//         "options":{
//             "synchronous":true,
//             // "consider_historic_traffic_info":true,
//             // "include_proposed_driver":false
//         }
//     })

//     return result
// }

// async function setActivity(date,duration,address){
//     return bumbalCall('/activity/set','POST',{
//         "nr":"50504",
//         "reference":"Tandarts 013 Olympiaplein",
//         "activity_type_name":"stop",
//         "duration":30,
//         "address":{
//             "street_1":"Ringbaan Noord",
//             "house_nr":"7",
//             "city":"Tilburg",
//             "zipcode":"5013EA",
//             "iso_country":"nl"
//         },
//         "links":[
//             {
//                 "link_id":"50504",
//                 "provider_name":"refrezh"
//             }
//         ],
//         "time_slots":[
//             {
//                 "date_time_from":"2026-07-22 10:30",
//                 "date_time_to":"2026-07-22 10:59"
//             }
//         ],
//         "tag_names":[
//             "blok","implant"
//         ],
//         "notes":[
//             {
//                 "content":"Treatment : Reparaties"
//             },
//             {
//                 "content":"Patient : W….."
//             }
//         ],
//         // "allowed_driver_ids":[
//         //     "24"
//         // ]
//     })
// }

// async function autoPlan(){
//     return bumbalCall('/planner/auto-plan','POST',{
//         "filters":{
//             "activity":{
//                 "links":[
//                     {
//                     "link_id":"50504",
//                     "provider_name":"refrezh"
//                     }
//                 ]
//             }
//         },
//         "options":{
//             "synchronous":true,
//             "respond_after_apply_planning":false,
//             "consider_historic_traffic_info":true,
//             "do_not_apply_planning":false,
//             "adjust_time_slots_to_planned_times":true
//         }
//     })
// }

// async function bumbalCall(path,method,body){
//     return fetch(`${__URLS__["api"]}paul/bumbalcall`,{
//         method: 'POST',
//         headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
//         },
//         body:JSON.stringify({
//             path,
//             method,
//             body,
//         })
//     }).then(res => res.json())
// }

// function timeout(ms) {
//     return new Promise(resolve => setTimeout(resolve, ms));
// }
























window.datumselectieloaded = async () => {
    var pieces = window.location.pathname.split('/')
    var orderid = parseInt(pieces[5])
    var productorder = (await window.getPaulAsync('productOrder','id',orderid))[0]
    productorder.orderBase = (await window.getPaulAsync('orderBase','productOrderId',productorder.id))[0]


    var upperProductType = null
    if(productorder.upperProductId){
        upperProductType = (await window.getPaulAsync('productType','id',productorder.upperProductId))[0]
    }

    var lowerProductType = null
    if(productorder.lowerProductId){
        lowerProductType = (await window.getPaulAsync('productType','id',productorder.lowerProductId))[0]
    }

    
    let vrijedagenstr = (await window.getPaulAsync('setting','id',32))[0].value
    let vrijedates = vrijedagenstr.split('\n').map(d => moment(d,"D-M"))

    
    datumselectie.innerHTML = ''

    var levertijd = Math.max(upperProductType?.levertijd ?? 0,lowerProductType?.levertijd ?? 0)

    if(productorder.orderBase.avaMaxUpper == 1 || productorder.orderBase.avaMaxLower == 1){
        levertijd += 7
    }
    
    let freedates = vrijedates.filter(d => d.isBetween(moment(),moment().add(levertijd,'days')))
    let validvrijedatescount = freedates?.length ?? 0
    levertijd += validvrijedatescount

    startContext(datumselectie)
        // text('hello from datumselectie')
        div({style:'display:flex;flex-direction:column;align-items:center; margin:20px;'})

            if(upperProductType?.nl?.includes('immediaat') || lowerProductType?.nl?.includes('immediaat')){
                div();text('Extractie/passen/plaatsen datum ');end()
            }else{
                div();text('Passen/plaatsen datum ');end()
            }

            for(let freedate of freedates){
                crend('div',`${moment(freedate).format('DD-MMM')} is een vrije dag`,{})
            }
            

            div({style:'display:flex;align-items:center;gap:4px;'})
                

                // <div></div>
                //     <div></div>
                //do something with rights
                
                

                if(moment().add(levertijd,'days').isoWeekday() == 6){
                    levertijd += 2
                }
                if(moment().add(levertijd,'days').isoWeekday() == 7){
                    levertijd += 1
                }


                let mindate = moment().add(levertijd,'days').format('YYYY-MM-DD')
                // if(hasRole([ROLES.Admin,ROLES.CS,ROLES.KPT])){
                //     mindate = moment().add(7,'days').format('YYYY-MM-DD')
                // }

                //check of uitersteleverdatum gezet moet worden

                if(window.activeproductorder?.gewensteleverdatum){
                    var value = moment(window.activeproductorder.gewensteleverdatum).format('YYYY-MM-DD')
                }else{
                    var value = moment().add(levertijd,'days').format('YYYY-MM-DD')
                    await update('productOrder',{
                        id:activeproductorder.id,
                        gewensteleverdatum:value,
                        deliveryDate:value,
                    })
                }
                //bug value is soms de huidige dag
                const deliveryDateInput = crend('input','',{name:'leverdatum',type:'date',value:value,min:moment().format('YYYY-MM-DD'),style:'cursor:pointer;'}).on('change',async (e) => {
                    //zeg hoeveel vrijedagen zijn toegevoegd  validvrijedatescount
                    // De gekozen datum is vroeger dan de standaard leverdatum ${moment(mindate).format('DD-MM-YYYY')}, weet u zeker dat u een spoedbestelling wil doen?
                    if(moment(e.target.value).isBefore(mindate)){
                        let res = await confirmDeliveryDate(`
De gewenste leverdatum is vroeger dan de standaard uiterste leverdatum. 
Deze is momenteel nog NIET BEVESTIGD, houdt hier rekening mee in uw planning. 
 
Indien de gewenste leverdatum mogelijk is wordt deze door onze Customer Service team bevestigd of zij nemen contact met u op om de mogelijkheden te bespreken. 
 
Indien spoed: bel direct met Customer Service om de mogelijkheden te bespreken: 088-7005555
 
Scans: Zorg dat de scan data in ieder geval direct wordt doorgestuurd, zodat hier geen vertraging in ontstaat.                            
    `)
                        if(res){
                            await update('productOrder',{
                                id:activeproductorder.id,
                                gewensteleverdatum:e.target.value,
                                gwldRequiresConfirmation:true,
                                gwldHasBeenConfirmed:false,
                                gwldConfirmationAnswer:null
                            })
                        }
                    }else{
                        await update('productOrder',{id:activeproductorder.id,gewensteleverdatum:e.target.value})
                    }
                    
                })
                cr('button', {type:'button', 'aria-label':'Kies gewenste leverdatum', style:'cursor:pointer;border:0;background:transparent;padding:4px;display:flex;align-items:center;'});
                    crend('i', '', {class:'fa fa-chevron-down', 'aria-hidden':'true', style:'font-size:12px;'});
                end().on('click', () => {
                    deliveryDateInput.focus();
                    if(typeof deliveryDateInput.showPicker === 'function'){
                        deliveryDateInput.showPicker();
                    }
                });
                setTimeout(() => {
                    tippy('#tooltipicon', {
                        content: `
Gewenste leverdatum gaat er vanuit dat de scans op dezelfde dag worden verstuurt naar AvaDent en dat deze bruikbaar zijn. Later verstuurde of onbruikbare/verkeerde scans kunnen invloed hebben op de gewenste en dus uiterste leverdatum. 
                        `,
                         trigger: 'mouseenter focus click',
                    });    
                }, 500);
                
            end()
        end()
    endContext()

}


function confirmDeliveryDate(message){
    return new Promise(resolve => {
        const dialog = document.createElement('dialog');
        dialog.style.cssText = 'width:560px;max-width:calc(100vw - 32px);box-sizing:border-box;padding:24px;border:1px solid #ccc;border-radius:12px;font:inherit;color:#000;background:#fff;';
        dialog.setAttribute('aria-labelledby', 'delivery-date-warning-title');

        const title = document.createElement('strong');
        title.id = 'delivery-date-warning-title';
        title.textContent = 'LET OP U WIJKT AF VAN DE STANDAARD LEVERTIJD:';
        title.style.fontWeight = '700';
        dialog.appendChild(title);

        const body = document.createElement('p');
        const emphasis = 'Deze is momenteel nog NIET BEVESTIGD';
        message.trim().split(emphasis).forEach((part, index) => {
            if(index > 0){
                const warning = document.createElement('strong');
                warning.textContent = emphasis;
                warning.style.fontWeight = '700';
                body.appendChild(warning);
            }
            body.appendChild(document.createTextNode(part));
        });
        body.style.whiteSpace = 'pre-line';
        dialog.appendChild(body);

        const actions = document.createElement('div');
        actions.style.cssText = 'display:flex;justify-content:flex-end;gap:12px;';
        for(const [label, value] of [['Annuleren', 'cancel'], ['OK', 'confirm']]){
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = label;
            button.style.cssText = 'padding:8px 16px;border:1px solid #000;border-radius:20px;cursor:pointer;';
            button.addEventListener('click', () => dialog.close(value));
            actions.appendChild(button);
        }
        dialog.appendChild(actions);
        dialog.addEventListener('close', () => {
            const confirmed = dialog.returnValue === 'confirm';
            dialog.remove();
            resolve(confirmed);
        }, {once:true});
        document.body.appendChild(dialog);
        dialog.showModal();
    });
}

async function update(table,data){
    await fetch(`${__URLS__["api"]}paul/${table}/update`,{
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem('Bearer')}`,
        },
        body:JSON.stringify(data)
    })
    .then(res => res.json())
}

window.update = update

















































function getQueryParam(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}


var contextStack = [[document.body]]

function currentContext(){
    return last(contextStack)
}

function last(arr){
    return arr[arr.length - 1]
}

function startContext(element){
    contextStack.push([element])
}

function endContext(){
    contextStack.pop()
}


function scr(tag,attributes = {}){
    flush()
    return cr(tag,attributes)
}



function cr(tag,attributes = {}){
    var parent = peek()
    var element = document.createElement(tag)
    if(parent){
        parent.appendChild(element)
    }
    for(var key in attributes){
        element.setAttribute(key,attributes[key])
    }
    currentContext().push(element)
    return element
}

function crend(tag,textstring,attributes = {}){
    cr(tag,attributes)
    text(textstring)
    return end()
}

function text(data){
    peek().textContent = data
    return peek()
}

function html(html){
    peek().innerHTML = html
}

function end(endelement = null){
    var poppedelement = currentContext().pop()
    if(endelement != null && endelement != poppedelement){
        console.warn(poppedelement,' doesnt equal ', endelement)
    }
    return poppedelement
}

HTMLElement.prototype.on = function(event,cb){
    this.addEventListener(event,cb)
    return this
}

function peek(){
    var context = currentContext()
    return last(context)
}

function flush(){
    var context = currentContext()
    var root = context[0]
    context.length = 0
    return root
}

function div(options = {}){
    return cr('div',options)
}

function a(options = {}){
    return cr('a',options)
}

function button(text,options = {}){
    return crend('button',text,options)
}

function input(options = {}){
    return crend('input',options)
}

function img(options = {}){
    return crend('img',options)
}


function stringToHTML (str) {
	var temp = document.createElement('template');
    
    temp.innerHTML = str;
    return temp.content.firstChild;
}

function upsertChild(parent,child){
    if(parent.firstChild){
        parent.replaceChild(child,parent.firstChild)
    }else{
        parent.appendChild(child)
    }
}

function qs(element,query){
    if(typeof element == 'string'){
        return document.body.querySelector(element)    
    }
    return element.querySelector(query)
}

function qsa(element,query){
    return Array.from(element.querySelectorAll(query))
}
